import { type AnchorHTMLAttributes, type ElementType, type Ref } from 'react'
import { Link as RRLink, type LinkProps as RRLinkProps } from 'react-router'

interface LinkProps
  extends AnchorHTMLAttributes<HTMLAnchorElement>, Partial<RRLinkProps> {
  ref?: Ref<HTMLAnchorElement>
}

function ForwardedRRLink({
  ref,
  ...props
}: RRLinkProps & { ref?: Ref<HTMLAnchorElement> }) {
  return <RRLink ref={ref} {...props} />
}

/**
 * A router link when given `to`, otherwise a plain anchor.
 */
export function Link({ ref, ...props }: LinkProps) {
  const Element: ElementType = props.to ? ForwardedRRLink : 'a'
  return <Element {...props} ref={ref} />
}
